import { render, staticRenderFns } from "./SalesmanModal.vue?vue&type=template&id=1c845e9e&"
import script from "./SalesmanModal.vue?vue&type=script&lang=js&"
export * from "./SalesmanModal.vue?vue&type=script&lang=js&"
import style0 from "./SalesmanModal.vue?vue&type=style&index=0&id=1c845e9e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports